import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { layers } from '@atlaskit/theme/constants';
import { SmartLinkSize } from '../../constants';
import { loadingPlaceholderClassName } from '../../index';
// Temporary fix for Confluence inline comment on editor mod has z-index of 500, Jira issue view has z-index of 510
export var HOVER_CARD_Z_INDEX = layers.modal();
export var flexibleUiOptions = {
  hideBackground: true,
  hideElevation: true,
  hideLegacyButton: true,
  size: SmartLinkSize.Medium,
  zIndex: HOVER_CARD_Z_INDEX + 1
};
export var CARD_WIDTH_REM = 24;
export var NEW_CARD_WIDTH_REM = 25;
// gap between mouse cursor and hover card
export var CARD_GAP_PX = 10;
var blockGap = '0.5rem';
var elementGap = '0.5rem';

/**
 * @deprecated remove on FF clean up bandicoots-compiled-migration-smartcard
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var separatorCss = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '[data-separator] + [data-separator]:before': {
    marginRight: elementGap
  }
});

/**
 * @deprecated remove on FF clean up bandicoots-compiled-migration-smartcard
 */
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var HoverCardContainer = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tbackground: none;\n\tborder-width: 0;\n\tbox-sizing: border-box;\n\twidth: ", "rem;\n\n\t.", " {\n\t\tdisplay: none;\n\t}\n"])), NEW_CARD_WIDTH_REM, loadingPlaceholderClassName);

/**
 * @deprecated remove on FF clean up bandicoots-compiled-migration-smartcard
 */
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var titleBlockCss = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tgap: ", ";\n\n\t", "\n\n\t// title and subtitle element group\n  [data-smart-element-group] {\n\t\t// gap between title and subtitle\n\t\tgap: 0.06rem;\n\t\tdisplay: flex;\n\t\t/* subtitle element group */\n\t\t> [data-smart-element-group] {\n\t\t\t> span {\n\t\t\t\tmargin-right: ", ";\n\t\t\t}\n\t\t}\n\t}\n\n\t[data-smart-element='Title'] {\n\t\tfont-weight: ", ";\n\t}\n"])), blockGap, separatorCss, elementGap, "var(--ds-font-weight-semibold, 600)");

/**
 * @deprecated remove on FF clean up bandicoots-compiled-migration-smartcard
 */
export var getTransitionStyles = function getTransitionStyles(snippetHeight) {
  return css({
    transition: 'height 300ms ease-in-out',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: "".concat(snippetHeight, "px")
  });
};

/**
 * @deprecated remove on FF clean up bandicoots-compiled-migration-smartcard
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var popupContainerStyles = css({
  borderRadius: "var(--ds-border-radius-200, 8px)",
  backgroundColor: "var(--ds-surface-overlay, white)",
  boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px rgba(9, 30, 66, 0.15),0px 0px 1px rgba(9, 30, 66, 0.31))"
});

/**
 * @deprecated remove on FF clean up bandicoots-compiled-migration-smartcard
 */
export var getPreviewBlockStyles = function getPreviewBlockStyles(previewHeight) {
  return (
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    css(previewHeight ? "height: ".concat(previewHeight, "px;") : '', {
      borderTopLeftRadius: "var(--ds-border-radius-200, 8px)",
      borderTopRightRadius: "var(--ds-border-radius-200, 8px)",
      marginBottom: blockGap
    })
  );
};